import React from 'react';

const ProfileIcon = ({ color = '#A6B0CF' }) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3334 13.3333C15.0957 13.3333 13.9088 12.8417 13.0336 11.9665C12.1584 11.0913 11.6667 9.90435 11.6667 8.66667C11.6667 7.42899 12.1584 6.24201 13.0336 5.36684C13.9088 4.49167 15.0957 4 16.3334 4C17.5711 4 18.7581 4.49167 19.6333 5.36684C20.5084 6.24201 21.0001 7.42899 21.0001 8.66667C21.0001 9.90435 20.5084 11.0913 19.6333 11.9665C18.7581 12.8417 17.5711 13.3333 16.3334 13.3333Z"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M7 27.3332V26.1665C7 24.31 7.7375 22.5295 9.05025 21.2168C10.363 19.904 12.1435 19.1665 14 19.1665H18.6667C20.5232 19.1665 22.3037 19.904 23.6164 21.2168C24.9292 22.5295 25.6667 24.31 25.6667 26.1665V27.3332"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export default ProfileIcon;
